import React from 'react';
import { Form, Input, InputNumber, Select, } from 'antd';

const { Option } = Select;

export const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    inputOptions,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode =
        inputType === 'number' ? <InputNumber /> :
            (inputType === 'vacationSelect' ? (
                <Select allowClear>
                    <Option value="0">没请假</Option>
                    <Option value="1">请半天假</Option>
                    <Option value="2">请全天假</Option>
                </Select>) :
                (inputType === 'select' ? (
                    <Select>
                        <Option value="true">TRUE</Option>
                        <Option value="false">FALSE</Option>
                    </Select>) :
                    (inputType === 'officeSelect' ?
                        <Select
                            allowClear
                            options={inputOptions}
                        /> :
                        <Input />
                    )
                )
            );
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        {
                            required: false,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};
